import { bootstrapApplication } from '@angular/platform-browser';
import {
  PreloadAllModules,
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withPreloading,
  withViewTransitions
} from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { register as registerSwiper } from 'swiper/element/bundle';
import localeDe from '@angular/common/locales/de';

import { routes } from '@app/app.routes';
import { AppComponent } from '@app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from '@app/core/interceptors/auth.interceptor';
import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import { mdTransitionAnimation } from "@ionic/angular";
import { init as initLogger } from "./app/shared/util/logger";

const sentryProviders = initLogger();

registerSwiper();
registerLocaleData(localeDe);

/* try to delete the service worker and its caches
* @see https://stackoverflow.com/q/57782617
*/
if ('caches' in window) {
  caches.keys()
    .then(function(keyList) {
      return Promise.all(keyList.map(function(key) {
        return caches.delete(key);
      }));
    })
}

if(window.navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations()
    .then(function(registrations) {
      for(let registration of registrations) {
        registration.unregister();
      }
    });
}

bootstrapApplication(AppComponent, {
  providers: [
    ...sentryProviders,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'longDate' } },
    { provide: LOCALE_ID, useValue: 'de-DE' },
    provideIonicAngular({
      mode: 'ios',
      backButtonText: '',
      navAnimation: mdTransitionAnimation,
      innerHTMLTemplatesEnabled: true,
    }),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withViewTransitions({
        skipInitialTransition: true
      }),
      withComponentInputBinding()
    ),
    provideHttpClient(withInterceptorsFromDi()),
  ],
});
